import React, { useEffect, useRef, useState } from 'react';
import { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import './index.scss';

export default function URLPreview({
  defaultValue,
  filterValue,
  onChange,
}: SingleCommonType) {
  const [urlList, setUrlList] = useState<Array<string>>([]);
  const isFirst = useRef(true);

  function initUrlList(data: any) {
    const urls = data?.content_urls || [];
    setUrlList(urls);
  }

  useEffect(() => {
    const { content_urls } = defaultValue;

    if (content_urls && isFirst.current) {
      initUrlList(defaultValue);
    }

    isFirst.current = false;
  }, []);

  // useEffect(() => {
  //   const { content_urls } = filterValue;

  //   if (content_urls && !isFirst.current) {
  //     initUrlList(filterValue);
  //   }
  // }, [filterValue]);

  useEffect(() => {
    onChange?.(
      'urlAnalysis',
      commonBackInfo({ content_urls: urlList }, { content_urls: urlList }),
    );
  }, [urlList]);

  return (
    <ul className="url-preview-wrapper">
      {urlList.map((item: string) => (
        <li key={item} className="url-preview-item">
          {item}
        </li>
      ))}
    </ul>
  );
}
